import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanDeactivate,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree,
} from '@angular/router'
import { MsalService } from '@azure/msal-angular'
import { Observable } from 'rxjs'
import { AzureService } from './azure.service'
import { environment } from 'src/environments/environment'

@Injectable({
  providedIn: 'root',
})
export class AuthGuard
  implements CanActivate, CanActivateChild, CanDeactivate<unknown>, CanLoad
{
  constructor(private authService: AzureService, private router: Router) {}

  showSettingsPage: boolean = false;

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    let url: string = state.url
    return this.checkUserLogin(next, url)
  }
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.canActivate(next, state)
  }
  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return true
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]
  ): Observable<boolean> | Promise<boolean> | boolean {
    return true
  }

  async checkUserLogin(
    route: ActivatedRouteSnapshot,
    url: any
  ): Promise<boolean> {
    const role = this.authService.selectedRole.subscribe(role => {
      this.showSettingsPage = environment.debugShowSettings || role === 'admin';
    });
    if (!this.showSettingsPage) {
      this.router.navigate(['/key-metrics'])
      return false //TODO: change
    }
    return true
  }
}
